<style lang="scss" scoped>
textarea {
  min-height: 10rem;
}
</style>

<template>
  <section>
    <div class="form-group row">
      <col-label>Inject im WWW Bereich im head</col-label>
      <div class="col-8">
        <textarea
          class="form-control"
          v-model="data.injectScriptCustomerBefore"
          rows="6"
        />
      </div>
    </div>
    <div class="form-group row">
      <col-label>Inject im WWW Bereich als letztes Element des Body</col-label>
      <div class="col-8">
        <textarea
          class="form-control"
          v-model="data.injectScriptCustomerAfter"
          rows="6"
        />
      </div>
    </div>
    <div class="form-group row">
      <col-label>Inject auf der Startseite im head</col-label>
      <div class="col-8">
        <textarea
          class="form-control"
          v-model="data.injectScriptHomeBefore"
          rows="6"
        />
      </div>
    </div>
    <div class="form-group row">
      <col-label
        >Inject auf der Startseite als letztes Element des Body</col-label
      >
      <div class="col-8">
        <textarea
          class="form-control"
          v-model="data.injectScriptHomeAfter"
          rows="6"
        />
      </div>
    </div>
    <div class="form-group row">
      <col-label>Inject auf der Konto verifiziert Seite (DOI)</col-label>
      <div class="col-8">
        <textarea
          class="form-control"
          v-model="data.injectScriptAfterEmailVerified"
          rows="6"
        />
      </div>
    </div>
    <div class="alert alert-info">
      Bei einem SOI entsteht keine voller Seitenaufruf. Daher wird der Inhalt
      der Textarea in ein script tag eingebunden. <br />
      Alle Inhalte sollten daher reines Javascript sein.
    </div>
    <div class="form-group row">
      <col-label>Inject auf der registriert Seite (SOI)</col-label>
      <div class="col-8">
        <textarea
          class="form-control"
          v-model="data.injectScriptAfterRegister"
          rows="6"
        />
      </div>
    </div>
    <div class="form-group">
      <button @click="persist()" class="btn btn-primary">Speichern</button>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("setting/all").then(() => {
      const settings = this.$store.getters["setting/all"];
      Object.keys(settings).forEach(key => {
        this.data[key] = settings[key];
      });
    });
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  data() {
    return {
      data: {
        injectScriptCustomerBefore: "",
        injectScriptCustomerAfter: "",
        injectScriptHomeBefore: "",
        injectScriptHomeAfter: "",
        injectScriptAfterEmailVerified: "",
        injectScriptAfterRegister: ""
      }
    };
  }
};
</script>
